import { IOrderItemDto } from "../interface/IOrderItem"
import {
  OrderItemType,
  PaymentParty,
  OrderItemStatus,
  OrderItemSubType,
} from "../enum/OrderEnum"

export const OrderItemDto: IOrderItemDto = {
  id: "",
  orderId: "",
  foodId: "",
  categoryIds: [],
  name: "",
  banner: "",
  originalPrice: 0,
  actualPrice: 0,
  quantity: 0,
  params: [],
  itemType: OrderItemType.Normal,
  payRecipient: PaymentParty.Merchant,
  payBy: PaymentParty.Customer,
  taxAmount: 0,
  subTotalExcludeTax: 0,
  isObsolete: false,
  merchPayoutBatchId: "",
  platformPayoutBatchId: "",
  reversalItemId: "",
  status: OrderItemStatus.Normal,
  transactionDate: "",
  subType: OrderItemSubType.FoodItem,
  helpText: "",
  externalId: "",
  canceledDate: "",
  canceledReason: "", // cancel 的原因
  isPriceAdjustable: false,
  calculateUnit: "",
  calculatedUnitPrice: 0,
  adjustableItemQuantities: [],
  canceledPrice: 0,
  subTotalReceivedByMerchantExcludeTax: 0,
  canceledOrderItemInfo: null,
}
